import React, { useState, useEffect } from 'react';
import { Box, Text, HStack, Icon } from '@chakra-ui/react';
import { RiTimeLine } from 'react-icons/ri';

const LagosTime = () => {
  const [time, setTime] = useState('');
  
  useEffect(() => {
    const updateTime = () => {
      const options = { 
        timeZone: 'Africa/Lagos',
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit',
        hour12: true
      };
      
      const lagosTime = new Date().toLocaleTimeString('en-US', options);
      setTime(lagosTime);
    };
    
    updateTime();
    const interval = setInterval(updateTime, 1000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <HStack spacing={2} align="center">
      <Icon as={RiTimeLine} color="cyan.400" />
      <Text fontSize="sm" color="gray.400" fontFamily="Space Grotesk" letterSpacing="wider">
        LAGOS {time}
      </Text>
    </HStack>
  );
};

export default LagosTime;